import { useLogHygiene } from '../../hooks/useLogHygiene';

function indicator(ok: boolean, warn: boolean): string {
  if (ok) return '✅';
  if (warn) return '🛑';
  return '⚠️';
}

export function LogHygieneCard() {
  const { data } = useLogHygiene();
  const cov = Math.round((data?.correlation_coverage ?? 0) * 100);
  const legacy = data?.legacy_event_count ?? 0;
  const redact = data?.redact_hits_last_5min ?? 0;

  return (
    <article className="rounded-lg border p-4">
      <header className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold">Log Hygiene</h3>
      </header>
      <dl className="space-y-1.5 text-sm">
        <div className="flex justify-between">
          <dt className="text-muted-foreground">Correlation coverage</dt>
          <dd className="font-medium">{cov}% {indicator(cov >= 95, cov < 80)}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="text-muted-foreground">Legacy events (5m)</dt>
          <dd className="font-medium">{legacy} {indicator(legacy === 0, legacy > 50)}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="text-muted-foreground">Redact hits (5m)</dt>
          <dd className="font-medium">{redact} {indicator(redact === 0, redact > 10)}</dd>
        </div>
      </dl>
    </article>
  );
}
